import Vue from 'vue';
import cookie from '../../cookie/cookie';
import { saveData, getData } from '../../utils/storage';
export default Vue.extend({
    name: 'tooltip',
    data: function () {
        return {
            flag: false,
            styleObj: {},
            usernameZh: '',
        };
    },
    props: {
        content: {
            type: Object,
            default: function () {
                return {};
            },
        },
        position: {
            default: 'top',
        },
        storageName: {
            type: String,
            default: '',
        },
    },
    created: function () {
        this.initPosition();
        this.getUserName();
        this.getStatus();
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        initPosition: function () {
            var isBottom = this.isBottom;
            var _a = this.content, left = _a.left, top = _a.top;
            !isBottom &&
                (this.styleObj = {
                    left: "calc(" + (left || 0) + ")",
                    top: "calc(" + (top || '-53px') + ")",
                });
            isBottom &&
                (this.styleObj = {
                    left: "calc(" + (left || 0) + ")",
                    top: "calc(" + (top || '-53px') + ")",
                });
        },
        getStatus: function () {
            var _a = this, storageName = _a.storageName, usernameZh = _a.usernameZh;
            var status = getData(storageName + "_" + usernameZh);
            this.flag = !status;
        },
        close: function () {
            var _a = this, storageName = _a.storageName, usernameZh = _a.usernameZh;
            saveData(storageName + "_" + usernameZh, true);
            this.flag = false;
            this.$emit('close-callback');
        },
    },
});
